import { render, staticRenderFns } from "./LanguageSelectionContextMenu.vue?vue&type=template&id=62d2f100"
import script from "./LanguageSelectionContextMenu.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectionContextMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports